// ============================================================================
// VERSIONE DEI DOCUMENTI LEGALI.
//
// Una data, un posto solo. Quando Termini o Privacy cambiano nel merito, si
// alza questa e tutti li riaccettano al primo accesso: e' il modo di sapere
// COSA ha accettato una persona, non solo che ha spuntato una casella qualche
// mese fa.
//
// Va alzata solo per modifiche sostanziali. Correggere un refuso non deve
// costringere trecento persone a rileggere.
//
// Il valore finisce in `users.termsVersion` insieme al momento
// dell'accettazione: quella coppia e' la prova.
// ============================================================================

export const TERMS_VERSION = '2026-09-08';

/** Percorsi dei due documenti, per i link dentro la casella di accettazione. */
export const TERMS_PATH = '/terms';
export const PRIVACY_PATH = '/privacy';
